import { UUID } from "../types/basetypes";
// WARNING : We cannot import any third party library here, because it seems to be loaded before the other modules. We should investigate this.

export const EMPTY_UUID: UUID = '00000000-0000-0000-0000-000000000000';

export function runningWithJest() {
    return process.env.JEST_WORKER_ID !== undefined;
}

export function toMap<K, T>(list: T[], keySelector: (item: T) => K): Map<K, T> {
    const map = new Map<K, T>();
    list.forEach(item => map.set(keySelector(item), item));
    return map;
}
